/* Ryedical Recipes — portal filtering, favourites, print/share, method steps */
(function () {
  'use strict';

  var FAV_KEY = 'ryedical-recipe-favs';

  function getFavs() {
    try {
      return JSON.parse(localStorage.getItem(FAV_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setFavs(favs) {
    try {
      localStorage.setItem(FAV_KEY, JSON.stringify(favs));
    } catch (e) {
      /* storage unavailable — hearts just won't persist */
    }
  }

  function initFavourites() {
    var favs = getFavs();
    var buttons = document.querySelectorAll('[data-rr-fav]');
    buttons.forEach(function (btn) {
      var handle = btn.getAttribute('data-rr-fav');
      if (favs.indexOf(handle) !== -1) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      }
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var current = getFavs();
        var index = current.indexOf(handle);
        if (index === -1) {
          current.push(handle);
        } else {
          current.splice(index, 1);
        }
        setFavs(current);
        // Sync every heart for this handle on the page (grid + related can both show it)
        document.querySelectorAll('[data-rr-fav="' + handle + '"]').forEach(function (b) {
          b.classList.toggle('is-active', index === -1);
          b.setAttribute('aria-pressed', index === -1 ? 'true' : 'false');
        });
      });
    });
  }

  function initPortalFilter() {
    var grid = document.querySelector('[data-rr-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-rr-card]'));
    var searchInput = document.querySelector('[data-rr-search-input]');
    var searchBtn = document.querySelector('[data-rr-search-btn]');
    var filterBtns = document.querySelectorAll('[data-rr-filter]');
    var countEl = document.querySelector('[data-rr-count]');
    var emptyEl = document.querySelector('[data-rr-empty]');
    var activeTag = 'all';

    function apply() {
      var query = searchInput ? searchInput.value.trim().toLowerCase() : '';
      var terms = query.split(/\s+/).filter(Boolean);
      var visible = 0;

      cards.forEach(function (card) {
        var tags = card.getAttribute('data-rr-tags') || '';
        var index = card.getAttribute('data-rr-search') || '';
        var tagMatch = activeTag === 'all' || tags.split(',').indexOf(activeTag) !== -1;
        var termMatch = terms.every(function (term) {
          return index.indexOf(term) !== -1;
        });
        var show = tagMatch && termMatch;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      if (countEl) {
        countEl.textContent = visible + (visible === 1 ? ' recipe' : ' recipes');
      }
      if (emptyEl) {
        emptyEl.hidden = visible !== 0;
      }
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeTag = btn.getAttribute('data-rr-filter');
        filterBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        apply();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', apply);
      searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') apply();
      });
    }
    if (searchBtn) {
      searchBtn.addEventListener('click', apply);
    }

    apply();
  }

  function initArticleActions() {
    var printBtn = document.querySelector('[data-rr-print]');
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        window.print();
      });
    }

    var shareBtn = document.querySelector('[data-rr-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var title = shareBtn.getAttribute('data-rr-share-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: window.location.href }).catch(function () {});
        } else {
          navigator.clipboard.writeText(window.location.href).then(function () {
            var label = shareBtn.querySelector('span');
            if (label) {
              var original = label.textContent;
              label.textContent = 'Link copied';
              setTimeout(function () {
                label.textContent = original;
              }, 2000);
            }
          });
        }
      });
    }

    document.querySelectorAll('[data-rr-step]').forEach(function (step) {
      step.addEventListener('click', function () {
        step.classList.toggle('is-done');
      });
      step.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          step.classList.toggle('is-done');
        }
      });
    });
  }

  function init() {
    initFavourites();
    initPortalFilter();
    initArticleActions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

